import React from 'react'
import PropTypes from 'prop-types'

import Text from './Text.jsx'
import { HEADER_THEME } from './constants'

import usePosition from '../hooks/usePosition'
import useRect from '../hooks/useRect'

function Header(props) {
  const { title, description, DelegatedRect } = props
  // THEME props
  const { titleProps, descriptionProps, spacing } = props

  const [titleRef, titleRect] = usePosition()
  const [descRef, descRect] = usePosition()

  const [Rect, rect] = useRect()

  const headerHeight = titleRect.height + descRect.height + spacing

  return (
    <svg x={0} y={0} width={'100%'} height={headerHeight}>
      <DelegatedRect />
      <Rect />
      <Text
        gRef={titleRef}
        value={title}
        fontSize={titleProps.size}
        fontWeight={700}
        textAnchor={titleProps.textAlign}
        lineHeight={titleProps.lineHeight}
        fill={titleProps.color}
        width={rect.width}
        x={0}
        y={0}
      />
      <Text
        gRef={descRef}
        value={description}
        fontSize={descriptionProps.size}
        textAnchor={descriptionProps.textAlign}
        lineHeight={descriptionProps.lineHeight}
        fill={descriptionProps.color}
        width={rect.width}
        x={0}
        y={titleRect.height + spacing}
      />
    </svg>
  )
}

const TEXT_PROPTYPES = {
  size: PropTypes.number,
  color: PropTypes.string,
}

Header.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  spacing: PropTypes.number,
  titleProps: PropTypes.shape(TEXT_PROPTYPES),
  descriptionProps: PropTypes.shape(TEXT_PROPTYPES),
  DelegatedRect: PropTypes.func,
}

Header.defaultProps = {
  ...HEADER_THEME.HORIZONTAL,
  title: '',
  description: '',
  DelegatedRect: () => {},
}

export default Header
